<template>
  <div class="translate-container">
    <select v-model="selected" @change="changeLanguage" :disabled="isTranslating">
      <option value="en">English</option>
      <option value="si">සිංහල</option>
      <option value="ta">தமிழ்</option>
    </select>
    <div v-if="isTranslating" class="translating-indicator">
      Translating...
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const selected = ref("en");
const isTranslating = ref(false);

function deleteAllGoogleTranslateCookies() {
  const cookies = document.cookie.split(";");

  cookies.forEach(cookie => {
    const [name] = cookie.split("=");
    if (name.trim() === "googtrans") {
      const hostnameParts = window.location.hostname.split(".");
      const baseDomain = hostnameParts.length > 2 ? hostnameParts.slice(-2).join(".") : window.location.hostname;

      const domains = [baseDomain, "." + baseDomain, window.location.hostname, "." + window.location.hostname, ""]; 
      const paths = ["/", "/"];

      domains.forEach(domain => {
        paths.forEach(path => {
          document.cookie = `googtrans=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${path};domain=${domain}`;
        });
      });
    }
  });
}


function setTranslateCookie(lang) {
  const domain = window.location.hostname === 'localhost'
    ? ''
    : `;domain=.${window.location.hostname}`;

  document.cookie = `googtrans=/en/${lang};path=/${domain}`;
  document.cookie = `googtrans=/en/${lang};path=/`;
}

async function changeLanguage() {
  isTranslating.value = true;
  const lang = selected.value;

  console.log("Changing language to:", lang);
  await deleteAllGoogleTranslateCookies();

  if (lang !== "en") {
    setTranslateCookie(lang);
  }

  setTimeout(() => location.reload(), 500);
}

onMounted(() => {
  sessionStorage.removeItem('languageChanging');
  const cookie = document.cookie.split("; ").find(c => c.startsWith("googtrans="));
  if (cookie) {
    const lang = cookie.split("/")[2];
    if (lang) {
      selected.value = lang;
    }
  }
});
</script>

<style scoped>
.translate-container {
  position: relative;
}

.translate-container select {
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}

.translate-container select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.translating-indicator {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: 8px;
  border-radius: 4px;
  margin-top: 4px;
  font-size: 12px;
  color: #495057;
}
</style>